export default __webpack_public_path__ + "static/media/Clan Bound Helm of the Greensward.e2a28ad7.jpg";